import { render, staticRenderFns } from "./DnsTable.vue?vue&type=template&id=d0a8875e&"
import script from "./DnsTable.vue?vue&type=script&lang=js&"
export * from "./DnsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports